import {RequestType, UyapRequest} from "./UyapRequest";

export interface PttBarkodSorgulaTalep {

}

export interface PttBarkodSorgulaCevap {
    message: string,
    status: "error"|"success",
    items: any[],
    updateData?: any
}

export default class PttBarkodSorgula extends UyapRequest<PttBarkodSorgulaTalep, PttBarkodSorgulaCevap> {
    delayTime = 250;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "PTT barkod sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 1), //* 1 gun
            key: "barkodptt_" + this.talepData
        };
    }

    getMockResponse(): any {
        return [
            {
                "almaHaberFlag": false,
                "almaHaberFlagSpecified": true,
                "errorMessage": "BAŞARILI",
                "errorState": true,
                "errorStateSpecified": true,
                "hareketDongu": [
                    {
                        "aciklama": "KABUL EDİLDİ",
                        "durum": 1,
                        "durumSpecified": true,
                        "icon_id": 1,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "ÇANKAYA",
                        "intSaat": 16282313,
                        "intSaatSpecified": true,
                        "intTarih": 20250220,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 14894,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "MUSTAFA KEMAL",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "ADLİYE İCRALAR",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "16:28:23",
                        "sicil_no": 257569,
                        "sicil_noSpecified": true,
                        "tarih": "20/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İL İÇİ AKTARMADA",
                        "durum": 3,
                        "durumSpecified": true,
                        "icon_id": 3,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "ÇANKAYA",
                        "intSaat": 16282320,
                        "intSaatSpecified": true,
                        "intTarih": 20250220,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 14894,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "MUSTAFA KEMAL",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "ADLİYE İCRALAR",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "16:28:23",
                        "sicil_no": 257569,
                        "sicil_noSpecified": true,
                        "tarih": "20/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İL İÇİ AKTARMADA",
                        "durum": 3,
                        "durumSpecified": true,
                        "icon_id": 3,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "YENİMAHALLE",
                        "intSaat": 18395011,
                        "intSaatSpecified": true,
                        "intTarih": 20250221,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 8789,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "ANKARA PİM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "ANKARA PİM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "18:39:50",
                        "sicil_no": 641444,
                        "sicil_noSpecified": true,
                        "tarih": "21/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İL İÇİ AKTARMADA",
                        "durum": 11,
                        "durumSpecified": true,
                        "icon_id": 3,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "KEÇİÖREN",
                        "intSaat": 7191857,
                        "intSaatSpecified": true,
                        "intTarih": 20250222,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 13961,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "KEÇİÖREN PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "KEÇİÖREN PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "07:19:18",
                        "sicil_no": 621261,
                        "sicil_noSpecified": true,
                        "tarih": "22/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "DAĞITIMDA",
                        "durum": 7,
                        "durumSpecified": true,
                        "icon_id": 4,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "KEÇİÖREN",
                        "intSaat": 9584073,
                        "intSaatSpecified": true,
                        "intTarih": 20250222,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 13961,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "KEÇİÖREN PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "KEÇİÖREN PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "09:58:40",
                        "sicil_no": 613889,
                        "sicil_noSpecified": true,
                        "tarih": "22/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İADE",
                        "durum": 151,
                        "durumSpecified": true,
                        "icon_id": 5,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "KEÇİÖREN",
                        "intSaat": 10151138,
                        "intSaatSpecified": true,
                        "intTarih": 20250224,
                        "intTarihSpecified": true,
                        "islem_detay": "Tanınmıyor",
                        "islem_merkezi": 13961,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "KEÇİÖREN PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "KEÇİÖREN PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "10:15:11",
                        "sicil_no": 613889,
                        "sicil_noSpecified": true,
                        "tarih": "24/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İL İÇİ AKTARMADA",
                        "durum": 3,
                        "durumSpecified": true,
                        "icon_id": 5,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "KEÇİÖREN",
                        "intSaat": 11254683,
                        "intSaatSpecified": true,
                        "intTarih": 20250225,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 13961,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "KEÇİÖREN PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "KEÇİÖREN PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "11:25:46",
                        "sicil_no": 621251,
                        "sicil_noSpecified": true,
                        "tarih": "25/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İL İÇİ AKTARMADA",
                        "durum": 44,
                        "durumSpecified": true,
                        "icon_id": 5,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "YENİMAHALLE",
                        "intSaat": 13422583,
                        "intSaatSpecified": true,
                        "intTarih": 20250226,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 13623,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "YENİMAHALLE PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "YENİMAHALLE PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "13:42:25",
                        "sicil_no": 613401,
                        "sicil_noSpecified": true,
                        "tarih": "26/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "DAĞITIMDA",
                        "durum": 7,
                        "durumSpecified": true,
                        "icon_id": 5,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "YENİMAHALLE",
                        "intSaat": 7094210,
                        "intSaatSpecified": true,
                        "intTarih": 20250227,
                        "intTarihSpecified": true,
                        "islem_detay": " ",
                        "islem_merkezi": 13623,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "YENİMAHALLE PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "YENİMAHALLE PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "07:09:42",
                        "sicil_no": 613401,
                        "sicil_noSpecified": true,
                        "tarih": "27/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    },
                    {
                        "aciklama": "İADE",
                        "durum": 120,
                        "durumSpecified": true,
                        "icon_id": 5,
                        "icon_idSpecified": true,
                        "il": "ANKARA",
                        "ilce": "YENİMAHALLE",
                        "intSaat": 11214205,
                        "intSaatSpecified": true,
                        "intTarih": 20250227,
                        "intTarihSpecified": true,
                        "islem_detay": "Göndericisine Teslim Edildi",
                        "islem_merkezi": 13623,
                        "islem_merkeziSpecified": true,
                        "islem_turu": "",
                        "isyeri": "YENİMAHALLE PDM",
                        "mazbata": false,
                        "mazbataSpecified": true,
                        "mazbata_aciklama": "",
                        "reserve1": "YENİMAHALLE PDM",
                        "reserve2": "",
                        "reserve3": "",
                        "reserve4": "",
                        "reserve5": "",
                        "saat": "11:21:42",
                        "sicil_no": 613401,
                        "sicil_noSpecified": true,
                        "tarih": "27/02/2025",
                        "teslim_ust_durum": null,
                        "yurtIciMi": 1,
                        "yurtIciMiSpecified": true
                    }
                ],
                "kabul": {
                    "agirlik": "20",
                    "alici": "B**** K*****",
                    "alici_adres": "Y********* M***",
                    "barkod_no": "4006994437064",
                    "damga_vergisi": "",
                    "deger_konulmus_bedeli": "0.00",
                    "desi": "0.00",
                    "ekhizmetler": "",
                    "gonderici": "A***** 1*",
                    "gonderici_adres": "",
                    "gumruge_sunma_ucreti": "",
                    "gumruk_vergisi": "",
                    "kabul_isyeri": "MUSTAFA KEMAL",
                    "kabul_tarihi": 20250220,
                    "kabul_tarihiSpecified": true,
                    "odeme_sarti_bedeli": "0.00",
                    "odeme_tipi": "UM",
                    "reserve1": "TEBLIGAT/UYAP",
                    "reserve2": "ANKARA/KEÇİÖREN",
                    "reserve3": " / ",
                    "reserve4": "",
                    "reserve5": "",
                    "toplam_yd_ucret": "",
                    "ucret": "210.00",
                    "yd_iade_ucreti": ""
                },
                "sondurum": {
                    "ahk_durum_aciklama": " ",
                    "ahk_teslim_alan": " ",
                    "ahk_teslim_tarihi": "0",
                    "mazb_dosya_no": " ",
                    "mazb_durum_aciklama": " ",
                    "mazb_islem_tarihi": "0",
                    "son_durum_aciklama": "İADE",
                    "son_islem_saati": "11214205",
                    "son_islem_tarihi": "20250227",
                    "sozl_durum_aciklama": " ",
                    "sozl_teslim_alan": " ",
                    "sozl_teslim_tarihi": "0",
                    "teslim_alan": "",
                    "teslim_durum_aciklama": " ",
                    "teslim_tarihi": "0"
                }
            }
        ];
    }

    getRequestType(): RequestType {
        return "json";
    }

    getUrl(): string {
        return "https://imza.eicrapro.com:6097/api/ShipmentTracking";
    }

    async parse(data: any): Promise<PttBarkodSorgulaCevap> {
        try {
            //return data;
            let div = document.createElement("div");
            let items: any[] = [];
            div.innerHTML = data;
            let alert = div.querySelector(".container .alert");

            if (alert) {
                return {
                    message: alert.innerHTML.replace("\n", "").trim(),
                    items: [],
                    status: "error"
                };
            }

            //@ts-ignore
            let durum = div.querySelector("main .container .row .col-8 h8").innerText;
            let list = div.querySelectorAll("#shipmentGroup tbody tr");

            list.forEach(item => {
                let tds = item.querySelectorAll("td");
                items.push({
                    tarih: tds[0].innerText,
                    islem: tds[1].innerText,
                    sube: tds[2].innerText,
                    il_ilce: tds[3].innerText,
                    aciklama: tds[4].innerText,
                });
            });

            // Teslimat ve bila kontrolü
            const teslimBilgisi = items.find(item => item.islem && item.islem.includes("TESLİM EDİLDİ"));
            const bilaBilgisi = items.find(item => item.islem && item.islem.includes("İADE"));


            // İlk işlem (gönderim tarihi) için
            const ilkIslem = items.length > 0 ? items[0] : null;

            // Update data
            let updateData = {
                barkodResponse: {
                    message: durum,
                    items: items,
                    status: "success"
                },
                tebligat_durumu: teslimBilgisi ? 'teslim_edildi' : (bilaBilgisi ? 'bila' : null),
                teslim_tarihi: teslimBilgisi?.tarih || null,
                bila_sebebi: bilaBilgisi?.aciklama || null,
                bila_tarihi: bilaBilgisi?.tarih || null,
                tebligat_gonderim_tarihi: ilkIslem?.tarih || null
            };

            return {
                message: durum,
                items: items,
                status: "success",
                updateData: updateData
            };
        } catch (error) {
            return {
                message: error instanceof Error ? error.message : "Bir hata oluştu",
                items: [],
                status: "error"
            };
        }
    }
}
